import type { ConfluenceSpace } from '../../types';

export const isConfluenceSpace = (entity: any): entity is ConfluenceSpace => {
	return entity.__typename === 'ConfluenceSpace';
};

export const getConfluenceSpaceLink = (space: ConfluenceSpace): string | null => {
	const { base, webUi } = space.links ?? {};

	if (!(base === undefined || webUi === undefined || base.length === 0 || webUi.length === 0)) {
		return `${base}${webUi}`;
	}
	return null;
};
